import { ProjectDetailMember } from "@models/data-contracts";
import BaseUserProfileViewModel from "@domains/common/viewModel/BaseUserProfileViewModel";

class ProjectMemberViewModel extends BaseUserProfileViewModel {
  memberId?: number;

  static create(responseData: ProjectDetailMember) {
    const participant = new ProjectMemberViewModel(responseData);

    participant.memberId = responseData.id;

    return participant;
  }
}

export default ProjectMemberViewModel;
